import { combineReducers } from 'redux'
import brands from './brands'
import categories from './categories'
import pages from './page'
import product from './product'
import products from './products'
import menu from './menus'
import err from './err'

export default combineReducers({
  brands,
  categories,
  menu,
  pages,
  product,
  products,
  err,
})
